export default "data:image/webp;base64,UklGRjAAAABXRUJQVlA4TCQAAAAvJwAGAAWRto2JqZ7p87MxgUCS67JjCQRSHMQQ9z9HXuvG5wU="